import { axios } from '@/utils/request'

export default {
    create(info){
        return axios.post('/api/services/app/School/Create',info)
    },
    update(info){
        return axios.put('/api/services/app/School/Update',info)
    },
    delete(id){
        return axios.delete('/api/services/app/School/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/School/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/School/GetAll',{params:page})
    },
    getBaseInfos(input){
        return axios.get('/api/services/app/School/GetBaseInfos',{params:input})
    }
}